module.exports = __webpack_public_path__ + "cf2f3b798ac1ba663391c3a78f4f9da3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/broschuere_image.jpg
// module id = 750
// module chunks = 0